import React from 'react'
import ConnectedComponent from '../../../../shared/connecter/ConnectedComponent'
import SimpleModalComponent from '../../../../shared/modal/SimpleModalComponent'
import {LevelContainer, ScoreContainer} from '../../containers/LevelContainer'
import {DiceScorePad} from './SharedLevelComponent'

import {DiceFlatComponent} from '../../../dice/components/DiceComponent'

class ScoreKey extends React.Component {
    triggerScore = () => {
        const {value, leverage, bonus} = this.props
        if (this.props.onChange) this.props.onChange(value * leverage + (value ? bonus : 0 ))
    }

    render() {
        const {value} = this.props
        return (
            <div className="col-md-4 col-sm-4 col-xs-4 text-center padkey" onClick={this.triggerScore}>
                {value || '/'}
            </div>
        )
    }
}


class ScorePad extends React.Component {
    triggerScore = (v) => {
        if (this.props.onChange) this.props.onChange(v)
    }

    render() {
        const {leverage, bonus} = this.props.conf.config
        const keys = []
        for (let i = 1; i < 7; i++) {
            keys.push(<ScoreKey onChange={this.triggerScore} key={'e' + i} value={i} leverage={leverage}
                                bonus={bonus}/>)
        }
        //keys.push(<ScoreKey onChange={this.triggerScore} key={'e0'} value={0} leverage={leverage} bonus={bonus}/>)
        //keys.push(<DeleteScoreKey onChange={this.triggerScore} key={'ex'} value={'x'} leverage={leverage} bonus={bonus}/>)
        return (
            <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-6 text-center">
                    <div className="padvalue">

                    </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="row pad">
                        {keys}
                    </div>
                </div>
            </div>
        )
    }
}


class DiceKey extends React.Component {
    triggerScore = () => {
        const {value, leverage, bonus} = this.props
        if (this.props.onChange) this.props.onChange(value * leverage + (value ? bonus : 0 ))
    }

    render() {
        const {value} = this.props
        return (
            <div className="col-md-2 col-sm-2 col-xs-2 text-center" onClick={this.triggerScore}>
                <DiceFlatComponent faceUp={value}/>
            </div>
        )
    }
}

class DiceScorePadWrapper extends React.Component {
    triggerScore = (v) => {
        if (this.props.onChange) this.props.onChange(v)
    }

    render() {
        const {leverage, bonus} = this.props.conf.config
        const keys = []
        for (let i = 1; i < 7; i++) {
            keys.push(<DiceKey onChange={this.triggerScore} key={'e' + i} value={i} leverage={leverage} bonus={bonus}/>)
        }
        return (<DiceScorePad onChange={this.triggerScore}> {keys} </DiceScorePad>
        )
    }
}

class ScorePadWrapper extends React.Component {
    render() {
        return (<DiceScorePad onChange={this.props.onChange}>
            {this.props.children}
        </DiceScorePad>)
    }
}

class ScoreComponent extends React.Component {

    constructor() {
        super()
        this.state = {
            edit: false
        }
    }

    triggerScore = (v) => {
        const {player, conf} = this.props
        if (this.props.onChange) this.props.onChange(player, conf, v)
        this.setState({
            edit: false
        })
    }

    editScore = () => {
        const {player, conf, mode} = this.props
        const content = mode === 'dices' ?
            <DiceScorePadWrapper onChange={this.triggerScore} conf={this.props.conf}/> :
            <ScorePadWrapper onChange={this.triggerScore} children={<ScorePad onChange={this.triggerScore} conf={this.props.conf}/>} />
        return this.state.edit ?
            <SimpleModalComponent title={ conf.config.name + ' pour ' + player.name } content={content}
                                  close={e => this.toggleEditScore(false)}/> : null
    }

    toggleEditScore = (status) => {
        this.setState({
            edit: status !== 'undefined' ? status : !this.state.edit
        })
    }


    render() {
        const {player, conf} = this.props
        const _score = player.scoreBoard.find(o => o.id === conf.id)
        const score = _score ? _score.value : 0
        return (
            <ScoreContainer level={this.props.conf}>
                {this.editScore()}
                <span onClick={this.toggleEditScore}>{_score ? score ? score : '/' : ''}</span>
            </ScoreContainer>)
    }
}


export default class OfAKindLevelComponent extends ConnectedComponent {

    constructor() {
        super()
        this.subscribe('players')
    }

    saveScore = (player, level, v) => {
        const playerScoreBoard = this.store.players.get(player.id).get('scoreBoard').filter(s => s.id !== level.id)
        if (v !== 'x') {
            playerScoreBoard.push({id: level.id, value: v})
        }
        this.store.players.get(player.id).set('scoreBoard', playerScoreBoard)
    }

    render() {


        const level = this.props.level
        const scores = this.store.players.toJSON().map(player => {
            return <ScoreComponent mode={this.props.settings.mode} onChange={this.saveScore} key={player.id}
                                   player={player} conf={level}/>
        })

        return (<LevelContainer className={this.props.className} bonus={level.config.bonus}
                                name={level.config.name}>{scores}</LevelContainer>)
    }
}


// WEBPACK FOOTER //
// ./src/game/level/components/types/OfAKindLevelComponent.jsx